import { isUndefined } from 'lodash-es';
import { useRef } from 'react';

import { container } from './TreeMapOverlay.sty.js';
import { useGraphSize } from '../../../core/components/chart-layout/hooks/useGraphSize.js';
import { useToolbarConfig } from '../../context/ToolbarContext.js';
import { useTreeMapAggregationData } from '../../context/TreeMapAggregationDataContext.js';
import { useOverlayHandlers } from '../../hooks/useOverlayHandlers.js';
import { useTooltipEventListeners } from '../../hooks/useTooltipEventListeners.js';
import {
  getNodesForTooltip,
  getSeriesActionsNodes,
} from '../../utils/get-nodes-for-tooltip.js';
import { TreeMapToolbar } from '../TreeMapToolbar/TreeMapToolbar.js';
import { TreeMapTooltip } from '../TreeMapTooltip/TreeMapTooltip.js';

export const TreeMapOverlay = () => {
  const tooltipRef = useRef<HTMLDivElement>(null);
  const { dataForRendering } = useTreeMapAggregationData();
  const leafNodes = getNodesForTooltip(dataForRendering.children);
  const seriesActionsNodes = getSeriesActionsNodes(leafNodes);
  const { width, height } = useGraphSize();
  const roundedWidth = Math.floor(width);
  const roundedHeight = Math.floor(height);

  const {
    onMouseMoveHandler,
    onMouseLeaveHandler,
    onClickHandler,
    onMouseEnterHandler,
  } = useOverlayHandlers();

  const toolbarConfig = useToolbarConfig();
  const shouldShowToolbar =
    !isUndefined(toolbarConfig) &&
    (!isUndefined(toolbarConfig.downloadData) ||
      !isUndefined(toolbarConfig?.intents));
  useTooltipEventListeners(tooltipRef.current);

  return (
    <div
      style={{ width: roundedWidth, height: roundedHeight }}
      className={container}
      onClick={onClickHandler}
      onMouseEnter={onMouseEnterHandler}
      onMouseMove={onMouseMoveHandler}
      onMouseLeave={onMouseLeaveHandler}
    >
      <TreeMapTooltip series={seriesActionsNodes} ref={tooltipRef} />
      {shouldShowToolbar && <TreeMapToolbar />}
    </div>
  );
};

TreeMapOverlay['displayName'] = 'TreeMapOverlay';
